// extracted by mini-css-extract-plugin
module.exports = {"ancestorInfo":"style_ancestorInfo__34Wt1","name":"style_name__3896u","contacts":"style_contacts__2ThmQ"};